/* Enhances the server-rendered Jim gallery. No-JS keeps :target viewers and month radios. */
(function () {
  var root = document.querySelector("[data-jim-gallery]");
  if (!root || !window.HTMLDialogElement) return;

  var cards = Array.prototype.slice.call(root.querySelectorAll(".jim-card"));
  if (!cards.length) return;

  var dialog = document.createElement("dialog");
  dialog.className = "jim-dialog";
  dialog.setAttribute("aria-modal", "true");
  dialog.innerHTML =
    '<div class="jim-dialog__panel">' +
    '<div class="jim-dialog__bar">' +
    '<button type="button" data-jim-close>Close</button>' +
    '<span data-jim-count></span>' +
    "</div>" +
    '<img class="jim-dialog__img" alt="" />' +
    '<div class="jim-dialog__copy">' +
    '<time data-jim-date></time>' +
    '<p class="jim-viewer__hamish" data-jim-hamish></p>' +
    '<h2 class="jim-viewer__title" data-jim-title></h2>' +
    '<p class="jim-viewer__caption" data-jim-caption></p>' +
    "</div>" +
    '<div class="jim-dialog__nav">' +
    '<button type="button" data-jim-prev>Previous</button>' +
    '<button type="button" data-jim-next>Next</button>' +
    "</div>" +
    "</div>";
  document.body.appendChild(dialog);

  var img = dialog.querySelector(".jim-dialog__img");
  var index = 0;
  var touchX = null;

  function visibleCards() {
    return cards.filter(function (card) {
      return card.offsetParent !== null || card.getClientRects().length > 0;
    });
  }

  function fill(card) {
    var list = visibleCards();
    index = Math.max(0, list.indexOf(card));
    var alt = card.getAttribute("data-alt") || "";
    img.src = card.getAttribute("data-web");
    img.width = Number(card.getAttribute("data-w")) || 1280;
    img.height = Number(card.getAttribute("data-h")) || 720;
    img.alt = alt;
    dialog.setAttribute("aria-label", alt);
    dialog.querySelector("[data-jim-date]").textContent = card.getAttribute("data-date-label") || "";
    dialog.querySelector("[data-jim-date]").setAttribute("datetime", card.getAttribute("data-date") || "");
    dialog.querySelector("[data-jim-hamish]").textContent = card.getAttribute("data-hamish") || "";
    dialog.querySelector("[data-jim-title]").textContent = card.getAttribute("data-title") || "";
    dialog.querySelector("[data-jim-caption]").textContent = card.getAttribute("data-caption") || "";
    dialog.querySelector("[data-jim-count]").textContent = card.getAttribute("data-no") || "";
    var prev = dialog.querySelector("[data-jim-prev]");
    var next = dialog.querySelector("[data-jim-next]");
    prev.disabled = index <= 0;
    next.disabled = index >= list.length - 1;
    prev.setAttribute("aria-label", "Previous plate");
    next.setAttribute("aria-label", "Next plate");
  }

  function openAt(card) {
    fill(card);
    if (!dialog.open) dialog.showModal();
    root.setAttribute("inert", "");
    dialog.querySelector("[data-jim-close]").focus();
  }

  function step(delta) {
    var list = visibleCards();
    var next = list[index + delta];
    if (next) fill(next);
  }

  root.addEventListener("click", function (event) {
    var link = event.target.closest(".jim-card__open");
    if (!link || !root.contains(link)) return;
    var card = link.closest(".jim-card");
    if (!card) return;
    event.preventDefault();
    openAt(card);
  });

  dialog.addEventListener("close", function () {
    root.removeAttribute("inert");
    img.removeAttribute("src");
  });

  dialog.addEventListener("click", function (event) {
    if (event.target.closest("[data-jim-close]")) dialog.close();
    if (event.target.closest("[data-jim-prev]")) step(-1);
    if (event.target.closest("[data-jim-next]")) step(1);
  });

  dialog.addEventListener("keydown", function (event) {
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      step(-1);
    } else if (event.key === "ArrowRight") {
      event.preventDefault();
      step(1);
    }
  });

  dialog.addEventListener(
    "touchstart",
    function (event) {
      touchX = event.changedTouches[0].clientX;
    },
    { passive: true }
  );
  dialog.addEventListener(
    "touchend",
    function (event) {
      if (touchX == null) return;
      var dx = event.changedTouches[0].clientX - touchX;
      touchX = null;
      if (dx > 48) step(-1);
      else if (dx < -48) step(1);
    },
    { passive: true }
  );
})();
